var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "firmwareUpdate" } },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("FirmwareVersion"),
            visible: _vm.dialogVisible,
            "modal-append-to-body": false,
            "close-on-click-modal": false,
            "destroy-on-close": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.viewClose,
          },
        },
        [
          _c(
            "div",
            { staticClass: "updateBox" },
            [
              _c("div", { staticClass: "printeUpdateBox" }, [
                _c("div", { staticClass: "boxLeft" }, [
                  _c("img", { attrs: { src: _vm.printe.img } }),
                ]),
                _c("div", { staticClass: "boxRight" }, [
                  _c("div", { staticClass: "rightModel" }, [
                    _c("div", { staticClass: "modelLeft" }, [
                      _vm._v(_vm._s(_vm.printe.model)),
                    ]),
                  ]),
                  _c("div", { staticClass: "rightCurVer" }, [
                    _c("div", { staticClass: "label" }, [
                      _vm._v(_vm._s(_vm.$t("FirmwareVersion"))),
                    ]),
                    _c("div", { staticClass: "version" }, [
                      _vm._v(_vm._s(_vm.printe.currentVersion)),
                    ]),
                  ]),
                  _c("div", { staticClass: "rightLastVer" }, [
                    _c("div", { staticClass: "label" }, [
                      _vm._v(_vm._s(_vm.$t("latest_version"))),
                    ]),
                    _c("div", { staticClass: "version" }, [
                      _c("div", { staticClass: "versionLeft" }, [
                        _vm._v(" " + _vm._s(_vm.printe.latestVersion) + " "),
                      ]),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.printe.need_update == "0" ||
                                _vm.printe.need_update == "1",
                              expression:
                                "printe.need_update == '0'||printe.need_update == '1'",
                            },
                          ],
                          staticClass: "priBtn",
                          class:
                            _vm.printe.need_update == "1" ? "" : "disableBtn",
                          on: { click: _vm.handleUpdate },
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("update_now")) + " ")]
                      ),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.printe.need_update == "2",
                              expression: "printe.need_update == '2'",
                            },
                          ],
                          staticClass: "updateLabel",
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.formmatStatus(_vm.printe.updateStatus)
                              ) +
                              _vm._s(
                                _vm.printe.progress
                                  ? `${_vm.printe.progress}%`
                                  : ""
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ]),
                  ]),
                ]),
              ]),
              _vm._l(_vm.boxs, function (item, index) {
                return _c("div", { key: index, staticClass: "boxUpdateBox" }, [
                  _c("div", { staticClass: "boxLeft" }, [
                    _c("img", { attrs: { src: item.img } }),
                  ]),
                  _c("div", { staticClass: "boxRight" }, [
                    _c("div", { staticClass: "rightModel" }, [
                      _c("div", { staticClass: "modelLeft" }, [
                        _vm._v(_vm._s(_vm.$t("ace_pro")) + _vm._s(index + 1)),
                      ]),
                    ]),
                    _c("div", { staticClass: "rightCurVer" }, [
                      _c("div", { staticClass: "label" }, [
                        _vm._v(_vm._s(_vm.$t("FirmwareVersion"))),
                      ]),
                      _c("div", { staticClass: "version" }, [
                        _vm._v(_vm._s(item.currentVersion)),
                      ]),
                    ]),
                    _c("div", { staticClass: "rightLastVer" }, [
                      _c("div", { staticClass: "label" }, [
                        _vm._v(_vm._s(_vm.$t("latest_version"))),
                      ]),
                      _c("div", { staticClass: "version" }, [
                        _c("div", { staticClass: "versionLeft" }, [
                          _vm._v(" " + _vm._s(item.latestVersion) + " "),
                        ]),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  item.need_update == "0" ||
                                  item.need_update == "1",
                                expression:
                                  "item.need_update == '0'||item.need_update == '1'",
                              },
                            ],
                            staticClass: "priBtn",
                            class: item.need_update == "1" ? "" : "disableBtn",
                            on: {
                              click: function ($event) {
                                return _vm.handleBoxUpdate(item)
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(_vm.$t("update_now")) + " ")]
                        ),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: item.need_update == "2",
                                expression: "item.need_update == '2'",
                              },
                            ],
                            staticClass: "updateLabel",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.formmatStatus(item.updateStatus)) +
                                _vm._s(
                                  item.progress ? `${item.progress}%` : ""
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]),
                    ]),
                  ]),
                ])
              }),
              _c("div", { staticClass: "tip" }, [
                _vm._v(_vm._s(_vm.$t("update_notice"))),
              ]),
            ],
            2
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }